import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  profile$: any;

  constructor( private http: HttpClient) { }
  profile(data): Observable<any> {
    return this.http.post<any>(environment.endpoints.updateprofile, data)
  }

}
